export const AdvertisingType = {
  Display: 'Display',
  Content: 'Contenido patrocinado',
  Clicks: 'Display Clicks'
}
